<table mat-table [dataSource]="tableData" class="mat-table">
  <!-- Dynamically Render Columns -->
  <ng-container *ngFor="let column of columnDefs" [matColumnDef]="column.key">
    <th
      mat-header-cell
      *matHeaderCellDef
      [class.text-align-end]="alignKeyText(column.label)">
      {{ column.label }}
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      [class.text-align-end]="alignKeyText(column.label)"
      [class.text-hyperlink]="identifyHyperLinks(column.key)">
      <ng-container *ngIf="identifyHyperLinks(column.key); else normalCell">
        <a
          href="javascript:void(0)"
          (click)="onHyperlinkClick(column.key, element)">
          {{ element[column.key] }}
        </a>
      </ng-container>

      <!-- Fallback: plain text -->
      <ng-template #normalCell>
        <ng-container *ngIf="shouldShowMasterShipment(column.key, element); else plainText">
          <div class="master-shipment-container">
            <span class="shipment-number">{{ element[column.key] }}</span>
            <div class="master-shipment-badge">
              <app-svg-icon
                [isStaticSvg]="true"
                [iconName]="'crown'"
                class="master-shipment-icon">
              </app-svg-icon>
              <span class="master-shipment-text">Master Shipment</span>
            </div>
          </div>
        </ng-container>
        
        <!-- Plain text for all other cells -->
        <ng-template #plainText>
          {{ element[column.key] }}
        </ng-template>
      </ng-template>
    </td>
  </ng-container>

  <!-- Optional Action Column -->
  <ng-container *ngIf="showActionButton" matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>Action</th>
    <td mat-cell *matCellDef="let element">
      @if (
        isFrom === 'air-waybill-commodity' || isFrom === 'air-waybill-piece'
      ) {
        <div
          class="action-btns-container"
          [class.action-btns-disabled]="disableActions">
          <app-svg-icon
            [isStaticSvg]="true"
            [iconName]="'edit'"
            class="table-actions"
            (click)="onAirwayActionClick(element, 'edit')"
            (keydown)="$event.stopPropagation()"></app-svg-icon>
          <app-svg-icon
            [isStaticSvg]="true"
            [iconName]="'delete'"
            class="table-actions"
            (click)="onAirwayActionClick(element, 'delete')"
            (keydown)="$event.stopPropagation()"></app-svg-icon>
        </div>
      } @else {
        <button
          mat-raised-button
          color="primary"
          (click)="onActionClick(element)">
          {{ actionButtonLabel }}
        </button>
      }
    </td>
  </ng-container>

  <!-- Header and Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  <!-- No Data Row -->
  <tr *ngIf="tableData?.length === 0">
    <td [attr.colspan]="displayedColumns.length" class="no-data-cell">
      No data found
    </td>
  </tr>
</table>

<ng-container *ngIf="tableData?.length === 0">
  <div class="ibc-grid-message-text initial-search-text">
    {{ noDataMessage }}
  </div>
</ng-container>
